import React, { useState, useEffect } from 'react';

import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import './login.css';
import { useNavigate } from "react-router-dom";
 
import { Toast } from '../components_root/ToastContext.jsx';
import { Randomcode } from '../components_root/rendom_code.js';
import { Randomnumber } from '../components_root/rendom_number.js';
import { MdAccountCircle, MdLogin, MdPassword } from 'react-icons/md';
import { Mobile_signIn } from '../firebase.js';
import Aooz from '../assets/aooz_name.png';
const sessionkey = Randomcode(6) + "_" + Randomcode(5) + "_" + Randomcode(4);

export default function Login() {
  const navigate = useNavigate();
  const [sendotppin, setSendotppin] = useState();
  const [otppin, setOtppin] = useState(sendotppin);
  const [mobile, setMobile] = useState("");
  const { Toastshow } = Toast();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  useEffect(() => {
    const existingsessionkey = Cookies.get("sessionkey");
    if (existingsessionkey !== null && existingsessionkey !== undefined) {
      navigate(-1);
    }
  }, [navigate]);

const handleLogin = async () => {
  // if (otppin !== sendotppin) {
  //   Toastshow("OTP do not match!");
  //   return;
  // }
 if (otppin.length < 5) {
   Toastshow("OTP do not match!");
    return;
  }
  if (mobile.length < 8) {
    Toastshow("Mobile number must be at least 8 digits!");
    return;
  }

  if (isSubmitDisabled) return;

  setIsSubmitDisabled(true);

  try {
   const res= await Mobile_signIn(mobile, otppin);
   if(!res.success)
   {Toastshow(res.error);
setIsSubmitDisabled(false);
   }
    // SUCCESS → redirect happens inside Mobile_signIn
  } catch (err) {
    setIsSubmitDisabled(false); // only re-enable on failure
    Toastshow(err.message || "Login failed");
  }
};



  return (
    <div>

      <Helmet>
        <title>Login | Aooz</title>
        <meta
          name="description"
          content="Securely log in to Aooz to access the Artfacel intelligent trade bot, integrated with Binance API for automated spot trading and portfolio protection."
        />
        <meta
          name="keywords"
          content="Aooz login, Artfacel trade bot access, secure crypto login, Binance API integration, crypto bot login, automated trading login, portfolio security"
        />
        <meta name="author" content="Aooz.in" />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Aooz Login | Access the Artfacel Trade Bot Securely"
        />
        <meta
          property="og:description"
          content="Log in to Aooz and start using the intelligent Artfacel trade bot for secure and automated Binance spot trading."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.Aooz.in/login" />
        <meta
          property="og:image"
          content="https://www.Aooz.in/assets/Aooz.png"
        />
      </Helmet>
 
 
      <div className="container_roots">
        <div className="container_size">
          <div className="form b-1 rounded"  >
            <div className="items-center center">
              <img className="aooz_logo" src={Aooz} alt="Aooz Logo" />
            </div>
            <div className="flex-column">
              <div className='text-h2 center bold'>Sign in your account</div>
            </div>
            <div className="flex-column">
              <label>Mobile</label>
            </div>
            <div >
              <input
                type="phone"
         
                className='p-2 text-h2'
                placeholder="Enter your Mobile number"
                required
                maxLength={20}
                value={mobile}
                onChange={(e) => {setMobile(e.target.value);
                setIsSubmitDisabled(false);
                }}
              />
            </div>

            <div  >
              <label>Password</label>
            </div>
            <div >
              <input
              onKeyDown={(e) => {if (e.key === 'Enter') {
                handleLogin();
              }}}
              
                type="password"
                className='p-2 text-h2'
                maxLength={8}
                placeholder="Enter your password"
                required
                value={otppin}
                onChange={(e) => {setOtppin(e.target.value);
                 setIsSubmitDisabled(false);
                }}
              />
            </div>
            <div
              onClick={() =>handleLogin()}
              className="button-ui fill p-2 cursor"
            >
              <MdLogin className="icon" />
              {isSubmitDisabled ? "Processing.." : "Login"}
            </div>
          </div>
        </div>
      </div>
 

    </div>
  );
}
